module.exports = __webpack_public_path__ + "img/5.9a35184a.jpg";